type Props = {
  kind: 'rate_limit' | 'generation_failed' | 'load_failed';
  onRetry?: () => void;
  onDismiss?: () => void;
};

const COPY: Record<Props['kind'], { title: string; body: string }> = {
  rate_limit: {
    title: "You've used all 3 plan generations for today.",
    body: "Come back tomorrow to update your plan.",
  },
  generation_failed: {
    title: "Couldn't reach Claude.",
    body: 'Your inputs are still here — try again.',
  },
  load_failed: {
    title: "Couldn't load your plan.",
    body: 'Refresh the page or try again in a moment.',
  },
};

export function PlanErrorCard({ kind, onRetry, onDismiss }: Props) {
  const copy = COPY[kind];
  return (
    <div
      style={{
        background: 'var(--color-bg-card)',
        border: '1px solid var(--color-warn-soft)',
        borderRadius: 12,
        padding: '20px 24px',
        marginBottom: 18,
      }}
    >
      <div className="eyebrow" style={{ color: 'var(--color-warn)' }}>▌ Heads up</div>
      <h3 style={{ fontSize: 16, fontWeight: 600, margin: '6px 0 4px', color: 'var(--color-text)' }}>{copy.title}</h3>
      <p style={{ color: 'var(--color-text-3)', fontSize: 13, margin: '0 0 14px' }}>{copy.body}</p>
      <div style={{ display: 'flex', gap: 10 }}>
        {onRetry && <button onClick={onRetry} className="btn btn-primary">Retry</button>}
        {onDismiss && (
          <button
            onClick={onDismiss}
            style={{ background: 'transparent', color: 'var(--color-text-3)', border: 0, padding: '10px 16px', fontSize: 13, cursor: 'pointer' }}
          >
            Dismiss
          </button>
        )}
      </div>
    </div>
  );
}
